import * as constActions from './mapConstActions';
import initialState from './mapInitialState';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constActions.GET_MAP_DATA_SUCCESS:
      return Object.assign({}, state, {
        mapData: [...action.pointsArr]
      });
    default:
      return state;
  }
}
